import { Button, Menu, Text, Tooltip } from "@mantine/core";
import { MdPalette } from "react-icons/md";
import { FiCheck, FiChevronDown } from "react-icons/fi";
import { COMPONENT_COLOR_LABELS } from "@multiconsult-group/multiplacer-core";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectArticleColorings, selectActiveArticleColoring } from "../../ViewerRedux/articleColoringSelectors";
import { setActiveArticleColoringId, setMcBimItemColorMode, setShowSystemColorLegend } from "../designSlice";

const colorModes = ["SYSTEM_AND_CLASS", "MULTIPLACER_COLORS", "MMI", "DISCIPLINE_COLORS", "PRIMARY_SYSTEM"] as const;

export const ComponentColoringMenu = () => {
  const dispatch = useAppDispatch();
  const articleFilters = useAppSelector(selectArticleColorings);
  const activeArticle = useAppSelector(selectActiveArticleColoring);
  const colorMode = useAppSelector(state => state.design.mcbimItemColorMode);

  const showLegend = useAppSelector(state => state.design.showSystemColorLegend);

  return (
    <Menu withinPortal position="bottom-start" shadow="xl" width={280}>
      <Menu.Target>
        <Tooltip label="Endre komponentfargelegging" withArrow position="bottom">
          <Button size="sm" variant="subtle" w={280} justify="space-between"
            leftSection={<MdPalette size={16} />} rightSection={<FiChevronDown size={14} />}
            styles={{ label: { width: "100%" } }}>
            <Text truncate fw={500}>Komponenter - {activeArticle?.label ?? COMPONENT_COLOR_LABELS[colorMode]}</Text>
          </Button>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Komponentfargelegging</Menu.Label>
        {colorModes.map(value => (
          <Menu.Item key={value} onClick={() => dispatch(setMcBimItemColorMode(value))}
            role="menuitemradio" aria-checked={!activeArticle && colorMode === value}
            leftSection={!activeArticle && colorMode === value ? <FiCheck size={16} color="var(--mantine-color-blue-6)" /> : null}>
            {COMPONENT_COLOR_LABELS[value]}
          </Menu.Item>
        ))}
        {articleFilters.length > 0 && <Menu.Divider />}
        {articleFilters.map(filter => <Menu.Item key={filter.id}
          onClick={() => dispatch(setActiveArticleColoringId(filter.id))}
          role="menuitemradio" aria-checked={activeArticle?.id === filter.id}
          leftSection={activeArticle?.id === filter.id ? <FiCheck size={16} color="var(--mantine-color-blue-6)" /> : null}>
          {filter.label}
        </Menu.Item>)}
        {!activeArticle && (colorMode === "PRIMARY_SYSTEM" || colorMode === "SYSTEM_AND_CLASS") && <>
          <Menu.Divider />
          <Menu.Item role="menuitemcheckbox" aria-checked={showLegend}
            closeMenuOnClick={false}
            leftSection={showLegend ? <FiCheck size={16} color="var(--mantine-color-blue-6)" /> : null}
            onClick={() => dispatch(setShowSystemColorLegend(!showLegend))}>
            Vis fargeforklaring
          </Menu.Item>
        </>}
      </Menu.Dropdown>
    </Menu>
  );
};
